export function calculateLwA({
  Kulissenspaltgeschwindigkeit,
  Schalldaempferbreite,
  Schalldaempferhoehe,
}) {
  let vStrom = parseFloat(Kulissenspaltgeschwindigkeit);
  let breite = parseFloat(Schalldaempferbreite);
  let hoehe = parseFloat(Schalldaempferhoehe);
  let S = (breite / 1000) * (hoehe / 1000);

  let lwa = -25 + 70 * Math.log10(vStrom) + 10 * Math.log10(S);
  return lwa;
}

export function formatLwA(lwa) {
  return lwa.toFixed(0) > 0 ? lwa.toFixed(0) : 0;
}
